import { Button } from '@/components/shadcn/button'
import { toast } from 'sonner'

const TOAST_VARIANTS = [
  { label: 'Default', onClick: () => toast('Default toast message') },
  { label: 'Success', onClick: () => toast.success('Success toast message') },
  { label: 'Info', onClick: () => toast.info('Info toast message') },
  { label: 'Warning', onClick: () => toast.warning('Warning toast message') },
  { label: 'Error', onClick: () => toast.error('Error toast message') },
] as const

export function ToastsSection() {
  return (
    <div className="space-y-3">
      <p className="text-xs text-muted-foreground">Click a button to preview each toast variant.</p>
      <div className="flex flex-wrap gap-2">
        {TOAST_VARIANTS.map(({ label, onClick }) => (
          <Button key={label} size="sm" variant="outline" onClick={onClick}>
            Toast {label}
          </Button>
        ))}
      </div>
    </div>
  )
}
